// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"closeButton__3NHca","stickyBannerContainer":"stickyBannerContainer__WTNFY","wrapper":"wrapper__1uaTD"};